import { ReactElement } from 'react';
import { PatientCentralIframe } from '../../shared/PatientCentralIframe';

export function EngagementTab(): ReactElement {
  return (
    <PatientCentralIframe
      url="https://retool.bariendo.com/apps/cb866470-fc49-11f0-8620-c31851ab51b7/Patient%20Central/%5BMedplum%5D%20POST%20Procedure/engagement?_embed=true"
      title="Engagement"
    />
  );
}
